<template>
  <div
    id="customizations"
    class="content"
  >
    <div id="content">
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-brush"></i> Personnalisation des Weezys
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Pour <strong>modifier</strong> les différentes entrées de la liste, sélectionnez un champ puis cliquez sur <strong>"<i class="far fa-check"></i> Valider les modifications"</strong>.
          <br>
          Pour <strong>annuler</strong> les modifications, cliquez sur "<strong><i class="far fa-times"></i> Annuler les modifications"</strong>.
          <br>
          Les lignes sont automatiquement ajoutées lors de la première connexion d'un Weezy.
          <br>
          Elles ne peuvent ni être ajoutées, ni être supprimées manuellement.
        </b-message>
      </div>
    </div>

    <customizationsTable
      id="customizationsTable"
      :weezys="weezys"
    />

  </div>
</template>

<script>
import customizationsTable from "@/components/customizationsTable";

import http from "@/modules/request";
export default {
  name: "configs",
  components: {
    customizationsTable
  },
  data() {
    return {
      weezyId: "",
      tts_speech_rate: "",
      tts_pitch: "",
      tts_challenge_started: "",
      tts_low_battery: "",
      tts_plugged_in: "",
      tts_update_available: "",
      tts_is_female_voice: "",
      game_sales_trigger: 1,
      weezys: []
    };
  },
  mounted() {
    this.getWeezys();
  },
  methods: {
    getWeezys() {
      http
        .get("/weezys")
        .then(response => {
          this.weezys = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    submitModify: function() {
      http
        .patch("/weezys/" + this.weezyId + "/customize", {
          config: {
            tts_speech_rate: this.tts_speech_rate,
            tts_pitch: this.tts_pitch,
            tts_challenge_started: this.tts_challenge_started,
            tts_low_battery: this.tts_low_battery,
            tts_plugged_in: this.tts_plugged_in,
            tts_update_available: this.tts_update_available,
            tts_is_female_voice: this.tts_is_female_voice,
            game_sales_trigger: this.game_sales_trigger
          }
        })
        .then(
          function(response) {
            this.succesToast("Personnalisation(s) modifiée(s) avec succés");
            this.getWeezys();
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de personnalisation");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    clearFields: function() {
      this.tts_challenge_started = "";
      this.tts_low_battery = "";
      this.tts_plugged_in = "";
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.weezyId = modified.id;
          this.tts_speech_rate = modified.tts_speech_rate;
          this.tts_pitch = modified.tts_pitch;
          this.tts_challenge_started = modified.tts_challenge_started;
          this.tts_low_battery = modified.tts_low_battery;
          this.tts_plugged_in = modified.tts_plugged_in;
          this.tts_update_available = modified.tts_update_available;
          this.tts_is_female_voice = modified.tts_is_female_voice;
          this.game_sales_trigger = modified.game_sales_trigger;
          this.submitModify();
        }
      }
    },
    errorToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}
</style>